import {UsersAPI} from "../api/UsersAPI"
import {BaseService} from "./BaseService"
import {EMPTY_PASSWORD, User} from "../models/User"
import {
	actionUserFetchAllCompleted,
	actionUserFetchCompleted,
	actionUserSaveCompleted,
	actionUserDeleteCompleted,
	actionDeleteUsersCompleted
} from "../store/users/actions"
import {
	actionCurrentUserCompleted, actionUserFetchByResetPasswordTokenCompleted,
	actionToastrWarning, actionUserForgotPasswordCompleted,
	actionUserLoginCompleted,
	actionUserLogout, actionUserResetPasswordCompleted, actionToastrInfo
} from "../store/global"
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions"
import {ErrorService} from "./ErrorService"
import _ = require('lodash')
import {Invoice} from "../models/Invoice";

export default class UsersService extends BaseService {

	static getAll() {
		let usersAPI: UsersAPI = new UsersAPI()
		usersAPI.getAll().then(UsersService.processResponse)
		.then((data) => actionUserFetchAllCompleted(UsersService.responseToUsers(data)))
		.catch(error =>ErrorService.handleError(error))
	}

	static save(user: User) {
		let usersAPI: UsersAPI = new UsersAPI()
		if (user.id) {
			usersAPI.put(UsersService.userToRequest(user)).then(UsersService.processResponse)
			.then((data) => {
				actionUserSaveCompleted(UsersService.responseToUser(data))
				actionSetTabStateItem(UsersService.responseToUser(data))
				actionSetTabItem(UsersService.responseToUser(data))
				actionToastrInfo("Info", "Podaci su uspešno snimljeni")
			})
			.catch(error => ErrorService.handleError(error))
		} else {
			usersAPI.post(UsersService.userToRequest(user)).then(UsersService.processResponse)
				.then((data) => {
					actionUserSaveCompleted(UsersService.responseToUser(data))
					actionSetTabItem(UsersService.responseToUser(data))
					actionSetTabStateItem(UsersService.responseToUser(data))
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static getOne (user: User) {
		const usersAPI: UsersAPI = new UsersAPI()
		usersAPI.get(user).then(UsersService.processResponse)
		.then((data) => {
			actionUserFetchCompleted(UsersService.responseToUser(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static delete(user: User) {
		const usersAPI: UsersAPI = new UsersAPI()
		usersAPI.delete(user).then(UsersService.processResponse).then(
			(data) => {
				actionUserDeleteCompleted(user)
				actionDeleteTabForItemId(user.id)
				actionToastrInfo("Info", "Podaci su uspešno obrisani")
			}
		).catch(error => {
			ErrorService.handleError(error)
		})
	}

	static deleteUsers(users: User[]) {

		const usersAPI: UsersAPI = new UsersAPI()
		let count = 0;
		users.forEach(user => {

			usersAPI.delete(UsersService.userToRequest(user)).then(UsersService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(user.id)
					actionToastrInfo("Info", "Podaci su uspešno obrisani")
					if(count === users.length)
						actionDeleteUsersCompleted(users)
				}
			).catch(error => {
				ErrorService.handleError(error)
			})
		});
	}

	static login (username: string, password: string) {
		const usersAPI: UsersAPI = new UsersAPI()
		usersAPI.login(username, password).then((response: any) => {
			if (response.status == 200) {
				actionUserLoginCompleted(response.data.data, '200')
			}
			else {
				actionUserLoginCompleted(null, null)
			}
		})
		.catch(error => ErrorService.handleError(error))
	}

	static currentUser () {
		const usersAPI: UsersAPI = new UsersAPI()
		usersAPI.currentUser().then(UsersService.processResponse)
		.then((data) => {
			actionCurrentUserCompleted(UsersService.responseToUser(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static forgotPasswordRequest (email: string) {
		const usersAPI: UsersAPI = new UsersAPI();
		usersAPI.forgotPasswordRequest(email)
			.then((response: any) => {
				const error = response.status !== 200;
				actionUserForgotPasswordCompleted(error)

			})
			.catch(error => ErrorService.handleError(error))
	}

	static getByResetPasswordToken (token: string): any {
		const usersAPI: UsersAPI = new UsersAPI()
		usersAPI.getByResetPasswordToken(token).then(UsersService.processResponse)
			.then((user) => {
				const error = !user;
				actionUserFetchByResetPasswordTokenCompleted(user, error);
			})
			.catch(error => {
				actionUserFetchByResetPasswordTokenCompleted(null, true);
				ErrorService.handleError(error)
			})
	}

	static resetPasswordRequest(userId: string, password: string) {
		const usersAPI: UsersAPI = new UsersAPI();
		usersAPI.resetPasswordRequest(userId, password).then(UsersService.processResponse)
			.then(user => {
				actionUserResetPasswordCompleted(!user);
			})
			.catch(error => {
				actionUserResetPasswordCompleted(true);
				ErrorService.handleError(error)
			})
	}

	static responseToUser (data: any): User {
		let user = new User()
		user.roleId = data.roleId
		user.firstName = data.firstName
		user.lastName = data.lastName
		user.email = data.email
		user.password = EMPTY_PASSWORD
		user.role = data.role
		user.isAdmin = data.isAdmin
		user.id = data.id
		user.uploads = data.uploads
		user.positionId = data.positionId
		user.roles = []
		try {
			user.roles = JSON.parse(data.roles)
		} catch (error) {
			user.roles = []
		}
		return user
	}

	static responseToUsers (data: any) {
		let users: User[] = []
		for (let user of data) {
			users.push(UsersService.responseToUser(user))
		}
		return users
	}

	static userToRequest (user: User): any {
		if (user.password == EMPTY_PASSWORD) delete user.password
		return user
	}

	static hasPermission(user: User, permission: string): boolean {
		if (user.isAdmin) {
			return true;
		}
		return _.includes(user.role.permissions, permission);
	}

	static hasAnyPermission(user: User, permissions: string[]): boolean {
		var permission

		if (user.isAdmin) {
			return true;
		}
		for (var i = 0, l = permissions.length; i < l; i++) {
			permission = permissions[i];
			if (_.includes(user.role.permissions, permission)) {
				return true;
			}
		}
		return false;
	}

	static hasAllPermissions(user: User, permissions: string[]): boolean {
		var permission

		if (user.isAdmin) {
			return true;
		}
		for (var i = 0, l = permissions.length; i < l; i++) {
			permission = permissions[i];
			if (_.includes(user.role.permissions, permission)) {
				return false;
			}
		}
		return true;
	}

	static userHasAnyRightInSector (user: User, sectorId: string): boolean {
		if (!sectorId) return false
		if (user.isAdmin) return true
		if (!Array.isArray(user.roles)) return false
		for (let role of user.roles) {
			// if department id is null it means that user has role in all departments
			if (role.departmentId == sectorId || !role.departmentId) return true
		}
		return false
	}
}
